import PDF from "./utility/PDF";
import { Rect } from "../../store/documents/DocumentReducer";

export function usePDF() {
  const splitIntoPages = async (file: File) => {
    try {
      return PDF.splitIntoPages(file);
    } catch (error) {
      console.log("PDF ERROR");
    }
  };

  const splitIntoImages = async (file: File) => {
    try {
      return PDF.splitIntoImages(file);
    } catch (error) {
      console.log("PDF ERROR");
    }
  };

  const splitIntoImagePromises = async (file: File) => {
    try {
      return PDF.splitIntoImagePromises(file);
    } catch (error) {
      console.log("PDF ERROR");
    }
  };

  const groupIntoSingle = async (files: File[], filename: string) => {
    try {
      return PDF.groupIntoSingle(files, filename);
    } catch (error) {
      console.log("PDF ERROR");
    }
  };

  const applySignaturesToPdf = async (
    file: File,
    signatures: { pageIndex: number; rect: Rect; dataUrl: string }[]
  ) => {
    try {
      return PDF.applySignaturesToPdf(file, signatures);
    } catch (error) {
      console.error("PDF merge error:", error);
    }
  };

  return {
    splitIntoPages,
    groupIntoSingle,
    splitIntoImages,
    splitIntoImagePromises,
    applySignaturesToPdf,
  };
}
